import { z } from 'zod'

export const problemSchema = z.object({
  code: z.string().optional(),
  message: z.string(),
  details: z.unknown().optional(),
})

export type Problem = z.infer<typeof problemSchema>
